<template lang="pug">
v-alert.white--text.mx-1(v-if="syncProducts" :color="syncAlert.color" dense border="top")
  v-row.ma-0.pa-0
    v-col.pa-0.ma-0.mr-2.shrink(v-if="syncAlert.status === 'error' || syncAlert.status === 'cancelled'")
      v-icon(small) mdi-exclamation-thick
    v-col.pa-0.ma-0
      span.caption {{ syncAlert.message }}
    v-col.pa-0.ma-0.ml-4.shrink(v-if="syncAlert.status === 'in_progress'")
      v-progress-circular(indeterminate :size="15" :width="1")
</template>

<script>
export default {
  name: "WoocommerceProductSyncAlert",
  props: ['company'],
  data: () => ({
    syncProducts: false,
    syncAlert: {
      color: 'primary',
      message: '',
      status: 'in_progress'
    }
  }),
  mounted () {
    this.$wamp.subscribe(`woocommerce-sync-progress:${this.company.id}`, (args, kwArgs) => {
      this.syncAlert.status = kwArgs.status
      if (kwArgs.status === 'in_progress') {
        if (kwArgs.done >= kwArgs.total) {
          this.syncProducts = false
        } else {
          this.syncAlert.color = 'primary'
          this.syncAlert.message = `Updating ${kwArgs.done} of ${kwArgs.total} products from ${kwArgs.source}`
          this.syncProducts = true
        }
      } else if (kwArgs.status === 'done') {
        this.syncProducts = true
        this.syncAlert.color = 'success'
        this.syncAlert.message = `All products from ${kwArgs.source} has been updated`
      } else if (kwArgs.status === 'error') {
        this.syncProducts = true
        this.syncAlert.color = 'error'
        this.syncAlert.message = `Error while updating products from ${kwArgs.source}`
      }
    })
  }
}
</script>

<style lang="scss" scoped>

</style>